import { render, staticRenderFns } from "./proposals.vue?vue&type=template&id=7c83fa60&scoped=true&"
import script from "./proposals.vue?vue&type=script&lang=js&"
export * from "./proposals.vue?vue&type=script&lang=js&"
import style0 from "./proposals.vue?vue&type=style&index=0&id=7c83fa60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83fa60",
  null
  
)

export default component.exports